import { render, staticRenderFns } from "./methodology.vue?vue&type=template&id=20e80c6a&scoped=true"
import script from "./methodology.vue?vue&type=script&lang=js"
export * from "./methodology.vue?vue&type=script&lang=js"
import style0 from "./methodology.vue?vue&type=style&index=0&id=20e80c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e80c6a",
  null
  
)

export default component.exports